import { Box } from "@mui/material";
import { Outlet } from 'react-router-dom';


export const DoActivityPage = () => {
    return <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}><Outlet /></Box>;
};
